import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-content-card',
  templateUrl: './no-content-card.component.html',
  styleUrls: ['./no-content-card.component.scss'],
})
export class NoContentCardComponent {
  @Input() showContentCard: boolean = true;

  @Input() text: string;

  @Input() absolutePosition: boolean = false;
}
